import videojs from "video.js";
import { createRoot } from "react-dom/client";
import "video.js/dist/video-js.css";
import styled from "./Settings.module.scss";
import { SettingsPopup } from "./SettingsPopup";
import { QualityType } from "@/features/player/model/types";

type VJPlayer = ReturnType<typeof videojs>;
const Component = videojs.getComponent("Component");

class VjsSettings extends Component {
    private vjPlayer: VJPlayer;
    private audioRef: React.RefObject<HTMLAudioElement>;
    private videoRef: React.RefObject<HTMLVideoElement>;
    public selectLang: string;
    public setSelectLang: (val: string) => void;
    public setQuality: (val: QualityType) => void;

    constructor(player: VJPlayer, options: any) {
        super(player, options);
        this.vjPlayer = player;
        this.audioRef = options.audioRef;
        this.videoRef = options.videoRef;
        this.selectLang = options.selectLang;
        this.setSelectLang = options.setSelectLang;
        this.setQuality = options.setQuality;

        this.el().classList.add(styled["vjs-settings"]);

        // Иконка громкости
        const button = videojs.dom.createEl("button", {
            className: `vjs-control vjs-button ${styled.settingIcon}`,
        }) as HTMLButtonElement;

        button.onclick = () => {
            this.el().classList.toggle(styled["open"]);
        };

        // Слайдеры
        const settingsContainer = videojs.dom.createEl("div", {
            className: `${styled["settings-sliders"]}`,
        });

        const root = createRoot(settingsContainer);

        const handleChangeSpeed = (val: number) => {
            if (this.videoRef) {
                this.videoRef.current.playbackRate = val;
            }
            if (this.audioRef) {
                this.audioRef.current.playbackRate = val;
            }
        };

        root.render(
            <SettingsPopup
                selectLang={this.selectLang}
                setSelectLang={this.setSelectLang}
                speed={this.vjPlayer.playbackRate() ?? 1}
                setSpeed={handleChangeSpeed}
                setQuality={this.setQuality}
            />,
        );

        this.el().appendChild(button);
        this.el().appendChild(settingsContainer);

        document.addEventListener("click", this.handleDocumentClick, true);
    }

    private handleDocumentClick = (e: MouseEvent) => {
        const target = e.target as Node;

        if (!this.el().contains(target)) {
            this.el().classList.remove(styled["open"]);
        }
    };

    dispose() {
        // Always clean up
        document.removeEventListener("click", this.handleDocumentClick, true);
        super.dispose();
    }

    createEl() {
        return videojs.dom.createEl("div", {
            className: `vjs-control ${styled["vjs-settings"]}`,
        });
    }
}

videojs.registerComponent("VjsSpeedRate", VjsSettings);

export default VjsSettings;
